import React, {
    useEffect,
    useState
  } from "react";
  
  import {
    useNavigate
  } from "react-router-dom";
  
  import {
    getAdminUsers
  } from "../api/adminApi";
  
  import "../styles/AdminUsers.css";
  
  
  const AdminUsers = () => {
  
    const navigate = useNavigate();
  
    const [users, setUsers] =
      useState([]);
  
    const [loading, setLoading] =
      useState(true);
  
    const [error, setError] =
      useState("");
  
  
    useEffect(() => {
  
      const loadUsers = async () => {
  
        try {
  
          setLoading(true);
          setError("");
  
          const response =
            await getAdminUsers();
  
          setUsers(
            response.data || []
          );
  
        } catch (error) {
  
          console.error(
            "ADMIN USERS ERROR:",
            error
          );
  
          setError(
            "Impossible de charger les utilisateurs."
          );
  
        } finally {
  
          setLoading(false);
  
        }
  
      };
  
      loadUsers();
  
    }, []);
  
  
    const handleUserClick = (userId) => {
  
      navigate(
        `/admin/users/${userId}`
      );
  
    };
  
  
    const getRoleLabel = (role) => {
  
      const roles = {
        athlete: "Athlète",
        staff: "Staff",
        lawyer: "Avocat / Agent",
        club: "Club",
        media: "Média",
        brand: "Marque",
        fan: "Fan"
      };
  
      return roles[role] || role;
  
    };
  
  
    const getStatusLabel = (status) => {
  
      const statuses = {
        pending: "En cours",
        verified: "Vérifié",
        rejected: "Rejeté"
      };
  
      return statuses[status] || status;
  
    };
  
  
    if (loading) {
      return (
        <div className="admin-users-loading">
          Chargement des utilisateurs...
        </div>
      );
    }
  
  
    return (
      <div className="admin-users-page">
  
        <div className="admin-users-header">
  
          <div>
            <h1>
              Liste des utilisateurs
            </h1>
  
            <p>
              Consultez et gérez les dossiers
              d'inscription CarrerUp.
            </p>
          </div>
  
        </div>
  
  
        {error && (
          <div className="admin-users-error">
            {error}
          </div>
        )}
  
  
        {!error && users.length === 0 && (
          <div className="admin-users-empty">
            Aucun utilisateur trouvé.
          </div>
        )}
  
  
        {!error && users.length > 0 && (
  
          <div className="admin-users-table-wrapper">
  
            <table className="admin-users-table">
  
              <thead>
                <tr>
                  <th>
                    Nom complet
                  </th>
  
                  <th>
                    Rôle
                  </th>
  
                  <th>
                    État
                  </th>
                </tr>
              </thead>
  
              <tbody>
  
                {users.map((user) => (
  
                  <tr
                    key={user.id}
                    onClick={() =>
                      handleUserClick(user.id)
                    }
                    className="admin-users-row"
                  >
  
                    <td>
                      <span className="admin-user-name">
                        {user.full_name ||
                          "Nom non renseigné"}
                      </span>
                    </td>
  
                    <td>
                      {getRoleLabel(
                        user.role
                      )}
                    </td>
  
                    <td>
  
                      <span
                        className={
                          `admin-status-badge ${
                            user.verification_status
                          }`
                        }
                      >
                        {getStatusLabel(
                          user.verification_status
                        )}
                      </span>
  
                    </td>
  
                  </tr>
  
                ))}
  
              </tbody>
  
            </table>
  
          </div>
  
        )}
  
      </div>
    );
  };
  
  export default AdminUsers;